import React, {useContext} from 'react';
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
import {ContentView, ThemeSetting} from '../../../index';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
import {AppMainStyled} from './index.style';
import clsx from 'clsx';
import AppContext from '../../../utility/AppContext';
import AppFixedFooter from './AppFixedFooter';
import {LayoutType} from '../../../../shared/constants/AppEnums';

const StandardLayout = (props) => {
  const {footer, layoutType, footerType} = useContext(AppContext);

  return (
    <AppMainStyled
      className={clsx(layoutType === LayoutType.BOXED ? 'boxed-layout' : '', {
        appMainFooter: footer && footerType === 'fluid',
        appMainFixedFooter: footer && footerType === 'fixed',
      })}>
      <AppSidebar />

      <Box className='main-content'>
        <Hidden mdDown>
          <Box className='main-container'>
            <AppHeader />
            <ContentView />
            <AppFixedFooter />
          </Box>
        </Hidden>

        <Hidden lgUp>
          <Box className='main-container-full'>
            <AppHeader />
            <ContentView />
            <AppFixedFooter />
          </Box>
        </Hidden>
      </Box>
      <ThemeSetting />
    </AppMainStyled>
  );
};

export default StandardLayout;
